import {
  ExchangeName,
  ExchangePositionI,
  UserId,
} from '@robotrader/common-types';
import { DataError, Either, UseCase } from '@robotrader/core-lib';

import { OperationRepository } from '@/modules/trader/domain';

interface GetUserExchangePositionsProps {
  userId: UserId;
  exchangeName: ExchangeName;
}

interface GetUserExchangePositionsUseCaseProps {
  operationRepository: OperationRepository;
}

export class GetUserExchangePositionsUseCase
  implements
    UseCase<
      GetUserExchangePositionsProps,
      Either<DataError, ExchangePositionI[]>
    >
{
  private operationRepository: OperationRepository;

  constructor({ operationRepository }: GetUserExchangePositionsUseCaseProps) {
    this.operationRepository = operationRepository;
  }

  async execute(
    props: GetUserExchangePositionsProps,
  ): Promise<Either<DataError, ExchangePositionI[]>> {
    const { userId, exchangeName } = props;

    const result = await this.operationRepository.getAllUserExchangePositions(
      userId,
      exchangeName,
    );

    return result;
  }
}
